<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Module" subTitle="Forms" />

    <ListModule />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListModule from "@/components/Pages/Master/Module/ListModule.vue";

export default defineComponent({
  name: "ListModulePage",
  components: {
    PageTitle,
    ListModule,
  },
});
</script>
